module.exports = __webpack_public_path__ + "img/nerostarx-logo.f72b6572.png";